import Footer from "../Components/Footer/Footer"
import NavBar from "../Components/NavBar/NavBar"


const NavAndFooter = ()=>{
  return <>
    <NavBar/>
    <Footer/>
  </>
}
export default  NavAndFooter